<template>
    <div class="learning" v-if="exam">
        <div v-if="isOutOfBounds">
            <div class="container pt-3 pb-3 text-center">
                Невалиден въпрос
            </div>
        </div>
        <div v-else>
            <questions-toolbar
                :current-question="currentQuestion"
                :total-questions="totalQuestions"
                :has-prev="hasPrevQuestion"
                @prev="prevQuestion()"
                :has-next="hasNextQuestion"
                @next="nextQuestion()"
                :allowed-questions="isFinished ? totalQuestions : maxCurrentQuestion"
                @navigateToQuestion="navigateToQuestion"
                @back="$router.push({ name: 'course', params: { course: course.id } })"
            />

            <div class="question-wrapper">
                <span class="question-swiper-arrow-left bi bi-arrow-left" v-if="hasPrevQuestion && arrowsVisible"></span>
                <span class="question-swiper-arrow-right bi bi-arrow-right" v-if="hasNextQuestion && arrowsVisible"></span>

                <div class="question-swiper">
                    <swiper
                        :slides-per-view="1"
                        @setTranslate="setSwiperTranslate"
                        @touchStart="onSwiperTouchStart"
                        @touchEnd="onSwiperTouchEnd"
                        @transitionEnd="onSwiperTransitionEnd"
                        :options="swiperOptions"
                    >
                        <swiper-slide>
                                <question
                                    :question="question"
                                    @selectedAnswer="setAnswer"
                                    :answer-state="answerState"
                                    ref="question"
                                    :answer="currentAnswer"
                                    :disabled="disabled || questionDisabled"
                                    :show-correct="isFinished"
                                    :topic="topic"
                                    :subject="subject"
                                />
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>
        <div class="footer">
            <router-link :to="{ name: 'course', params: { course: course.id } }">
                <img src="/img/logo.png" alt="kapitani.bg logo" class="logo">
            </router-link>
        </div>
    </div>
</template>

<script>
    import courses from '../../data/courses';
    import ExamBuilder from '../../services/ExamBuilder'

    export default {
        data() {
            return {
                exam: null,
                isOutOfBounds: false,
                maxCurrentQuestion: 1,
                course: null,
                questionDisabled: false,
                isSwiperMoving: false,
                swiperTranslation: 0,
                arrowsVisible: false,
            }
        },

        computed: {
            hasPrevQuestion() {
                return this.currentQuestion > 1;
            },

            hasNextQuestion() {
                return this.isFinished ||
                    this.currentQuestion < (this.isFinished ? this.totalQuestions : this.maxCurrentQuestion);
            },

            swiperOptions() {
                return {
                    edgeSwipeDetection: 'prevent',
                    // passiveListeners: false,
                };
            },

            currentAnswer() {
                if (!this.exam || !this.question) {
                    return null;
                }

                const question = this.question;
                const answerId = this.exam.answers[question.id];

                if (!answerId) {
                    return null;
                }

                return question.answers.filter((answer) => answer.id == answerId)[0];
            },

            disabled() {
                return this.isFinished;
            },

            isFinished() {
                return this.exam ? this.exam.finished : false;
            },

            currentQuestion() {
                return this.exam ? this.exam.currentQuestion : 0;
            },

            questions() {
                return this.exam ? this.exam.questions : [];
            },

            totalQuestions() {
                return this.questions.length;
            },

            question() {
                return this.questions[this.currentQuestion - 1];
            },

            topic() {
                return this.course && this.question ? this.course.findTopic(this.question.topicId): null;
            },

            subject() {
                return this.course && this.question ? this.course.findSubject(this.question.subjectId): null;
            },

            answerState() {
                if (!this.currentAnswer) {
                    return null;
                }

                if (!this.isFinished) {
                    return 'preview';
                }

                return this.currentAnswer.isCorrect ? 'correct' : 'wrong';
            },
        },

        methods: {
            onSwiperTouchStart() {
                this.isSwiperMoving = true;
                this.arrowsVisible = true;
            },
            onSwiperTouchEnd() {
                this.isSwiperMoving = false;

                if (this.swiperTranslation > -10 && this.swiperTranslation < 10) {
                    this.arrowsVisible = false;
                }
            },
            onSwiperTransitionEnd() {
                let translation = this.swiperTranslation;
                this.swiperTranslation = 0;
                this.arrowsVisible = false;

                if (translation > 60) {
                    if (this.hasPrevQuestion) {
                        this.prevQuestion();
                    }
                }

                if (translation < -60) {
                    if (this.hasNextQuestion) {
                        this.nextQuestion()
                    }
                }
            },
            setSwiperTranslate(swiper, translation) {
                if (this.isSwiperMoving) {
                    this.swiperTranslation = translation;
                }
            },
            prevQuestion() {
                let question = null;

                if (this.currentQuestion - 1 < 1) {
                    question = this.questions.length;
                }
                else {
                    question = this.currentQuestion - 1;
                }

                this.$router.push({
                    name: 'exam.question',
                    params: {
                        question,
                    }
                });
            },

            nextQuestion() {
                let question = null;

                if (this.currentQuestion + 1 > this.questions.length) {
                    this.showResults();
                    return;
                }
                else {
                    question = this.currentQuestion + 1;
                }

                this.$router.push({
                    name: 'exam.question',
                    params: {
                        course: this.course.id,
                        question,
                    }
                });
            },

            showResults() {
                this.exam.finished = true;
                this.exam.save();

                this.$router.push({
                    name: 'exam.result',
                    params: {
                        course: this.course.id,
                    }
                });
            },

            reset() {
                this.questionDisabled = false;
                if (this.$refs.question) {
                    this.$refs.question.resetCurrentAnswer();
                }
            },

            setCurrentCourse(id) {
                this.course = courses.find(course => parseInt(course.id, 10) === parseInt(id, 10))
            },

            setCurrentQuestion(currentQuestion) {
                this.isOutOfBounds = this.isQuestionOutOfBounds(currentQuestion);

                if (!this.isOutOfBounds) {
                    this.exam.currentQuestion = parseInt(currentQuestion, 10);
                    this.exam.save();
                }

                this.maxCurrentQuestion = Object.keys(this.exam.answers).length + 1;
                this.reset();
            },

            loadExam(courseId, currentQuestion) {
                this.setCurrentCourse(courseId);
                this.exam = ExamBuilder.load(this.course);
                this.setCurrentQuestion(currentQuestion);
            },

            setAnswer(answer) {
                this.$set(this.exam.answers, this.question.id, answer.id);
                this.exam.save();

                if (document.activeElement) {
                    document.activeElement.blur()
                }

                this.questionDisabled = true;

                this.$nextTick(
                    () => setTimeout(() => {
                        this.maxCurrentQuestion = Object.keys(this.exam.answers).length + 1;
                        this.nextQuestion();
                    }, 200)
                );
            },

            isQuestionOutOfBounds(question) {
                return isNaN(question) || question > this.questions.length;
            },

            navigateToQuestion(question) {
                this.$router.push({
                    name: 'exam.question',
                    params: {
                        question,
                        course: this.course.id,
                    }
                });
            }
        },

        beforeRouteEnter (to, from, next) {
            next(vm => vm.loadExam(to.params.course, to.params.question));
        },

        // when route changes and this component is already rendered,
        // the logic will be slightly different.
        beforeRouteUpdate (to, from, next) {
            this.setCurrentCourse(to.params.course)
            this.setCurrentQuestion(to.params.question)
            next()
        }
    }
</script>